import { defineMessages } from 'react-intl';

const messages = defineMessages({
  'Africa/Cairo': {
    defaultMessage: '(GMT+02:00) Egypt Standard Time (Cairo)',
    id: '1BjFqb',
    description: 'Africa/Cairo, TimeZone Offset: +02:00',
  },
  'Africa/Johannesburg': {
    defaultMessage: '(GMT+02:00) South Africa Standard Time (Harare, Pretoria)',
    id: 'ZJYQy9',
    description: 'Africa/Johannesburg, TimeZone Offset: +02:00',
  },
  'Africa/Lagos': {
    defaultMessage: '(GMT+01:00) W. Central Africa Standard Time (West Central Africa)',
    id: 'ZMvT9G',
    description: 'Africa/Lagos, TimeZone Offset: +01:00',
  },
  'Africa/Nairobi': {
    defaultMessage: '(GMT+03:00) E. Africa Standard Time (Nairobi)',
    id: '3aakjg',
    description: 'Africa/Nairobi, TimeZone Offset: +03:00',
  },
  'America/Anchorage': {
    defaultMessage: '(GMT-09:00) Alaskan Standard Time (Alaska)',
    id: 'uQpT3n',
    description: 'America/Anchorage, TimeZone Offset: -09:00',
  },
  'America/Bogota': {
    defaultMessage: '(GMT-05:00) S.A. Pacific Standard Time (Bogota, Lima, Quito)',
    id: 'UOHJ+q',
    description: 'America/Bogota, TimeZone Offset: -05:00',
  },
  'America/Cayenne': {
    defaultMessage: '(GMT-03:00) S.A. Eastern Standard Time (Buenos Aires, Georgetown)',
    id: 'pEt7KJ',
    description: 'America/Cayenne, TimeZone Offset: -03:00',
  },
  'America/Chicago': {
    defaultMessage: '(GMT-06:00) Central Standard Time (Central Time (US and Canada))',
    id: 'LEezNI',
    description: 'America/Chicago, TimeZone Offset: -06:00',
  },
  'America/Chihuahua': {
    defaultMessage: '(GMT-07:00) Mexico Standard Time 2 (Chihuahua, La Paz, Mazatlan)',
    id: 'bv711p',
    description: 'America/Chihuahua, TimeZone Offset: -07:00',
  },
  'America/Denver': {
    defaultMessage: '(GMT-07:00) Mountain Standard Time (Mountain Time (US and Canada))',
    id: 'inhN9W',
    description: 'America/Denver, TimeZone Offset: -07:00',
  },
  'America/Godthab': {
    defaultMessage: '(GMT-03:00) Greenland Standard Time (Greenland)',
    id: '6Gy51T',
    description: 'America/Godthab, TimeZone Offset: -03:00',
  },
  'America/Guatemala': {
    defaultMessage: '(GMT-06:00) Central America Standard Time (Central America)',
    id: 'uLoG4K',
    description: 'America/Guatemala, TimeZone Offset: -06:00',
  },
  'America/Halifax': {
    defaultMessage: '(GMT-04:00) Atlantic Standard Time (Atlantic Time (Canada))',
    id: 'mtpMmm',
    description: 'America/Halifax, TimeZone Offset: -04:00',
  },
  'America/Indiana/Indianapolis': {
    defaultMessage: '(GMT-05:00) U.S. Eastern Standard Time (Indiana)',
    id: 'bywgjR',
    description: 'America/Indiana/Indianapolis, TimeZone Offset: -05:00',
  },
  'America/La_Paz': {
    defaultMessage: '(GMT-04:00) S.A. Western Standard Time (Caracas, La Paz)',
    id: 'kukznW',
    description: 'America/La_Paz, TimeZone Offset: -04:00',
  },
  'America/Los_Angeles': {
    defaultMessage: '(GMT-08:00) Pacific Standard Time (Pacific Time (US and Canada), Tijuana)',
    id: 'faKxog',
    description: 'America/Los_Angeles, TimeZone Offset: -08:00',
  },
  'America/Mexico_City': {
    defaultMessage: '(GMT-06:00) Mexico Standard Time (Guadalajara, Mexico City, Monterrey)',
    id: 'UbdY7m',
    description: 'America/Mexico_City, TimeZone Offset: -06:00',
  },
  'America/New_York': {
    defaultMessage: '(GMT-05:00) Eastern Standard Time (Eastern Time (US and Canada))',
    id: 'EPVckt',
    description: 'America/New_York, TimeZone Offset: -05:00',
  },
  'America/Phoenix': {
    defaultMessage: '(GMT-07:00) U.S. Mountain Standard Time (Arizona)',
    id: 'jm7+zy',
    description: 'America/Phoenix, TimeZone Offset: -07:00',
  },
  'America/Regina': {
    defaultMessage: '(GMT-06:00) Canada Central Standard Time (Saskatchewan)',
    id: 'U3oZ3c',
    description: 'America/Regina, TimeZone Offset: -06:00',
  },
  'America/Santiago': {
    defaultMessage: '(GMT-04:00) Pacific S.A. Standard Time (Santiago)',
    id: '9d5MQp',
    description: 'America/Santiago, TimeZone Offset: -04:00',
  },
  'America/Sao_Paulo': {
    defaultMessage: '(GMT-03:00) E. South America Standard Time (Brasilia)',
    id: 'vu0Xxd',
    description: 'America/Sao_Paulo, TimeZone Offset: -03:00',
  },
  'America/St_Johns': {
    defaultMessage: '(GMT-03:30) Newfoundland and Labrador Standard Time (Newfoundland)',
    id: 'EWDe2N',
    description: 'America/St_Johns, TimeZone Offset: -03:30',
  },
  'Asia/Almaty': {
    defaultMessage: '(GMT+06:00) Central Asia Standard Time (Astana, Dhaka)',
    id: 'iQN0y6',
    description: 'Asia/Almaty, TimeZone Offset: +06:00',
  },
  'Asia/Baghdad': {
    defaultMessage: '(GMT+03:00) Arabic Standard Time (Baghdad)',
    id: 'tGwCrG',
    description: 'Asia/Baghdad, TimeZone Offset: +03:00',
  },
  'Asia/Bangkok': {
    defaultMessage: '(GMT+07:00) S.E. Asia Standard Time (Bangkok, Hanoi, Jakarta)',
    id: 'vnD6yZ',
    description: 'Asia/Bangkok, TimeZone Offset: +07:00',
  },
  'Asia/Colombo': {
    defaultMessage: '(GMT+06:00) Sri Lanka Standard Time Sri (Jayawardenepura)',
    id: 'MnSqVo',
    description: 'Asia/Colombo, TimeZone Offset: +06:00',
  },
  'Asia/Dubai': {
    defaultMessage: '(GMT+04:00) Arabian Standard Time (Abu Dhabi, Muscat)',
    id: 'Wtsefb',
    description: 'Asia/Dubai, TimeZone Offset: +04:00',
  },
  'Asia/Irkutsk': {
    defaultMessage: '(GMT+08:00) North Asia East Standard Time (Irkutsk, Ulaanbaatar)',
    id: 'JN3xVK',
    description: 'Asia/Irkutsk, TimeZone Offset: +08:00',
  },
  'Asia/Jerusalem': {
    defaultMessage: '(GMT+02:00) Israel Standard Time (Jerusalem)',
    id: 'orpnJA',
    description: 'Asia/Jerusalem, TimeZone Offset: +02:00',
  },
  'Asia/Kabul': {
    defaultMessage: '(GMT+04:30) Transitional Islamic State of Afghanistan Standard Time (Kabul)',
    id: 'wCZ1YY',
    description: 'Asia/Kabul, TimeZone Offset: +04:30',
  },
  'Asia/Kathmandu': {
    defaultMessage: '(GMT+05:45) Nepal Standard Time (Kathmandu)',
    id: '+MnlJJ',
    description: 'Asia/Kathmandu, TimeZone Offset: +05:45',
  },
  'Asia/Kolkata': {
    defaultMessage: '(GMT+05:30) India Standard Time (Chennai, Kolkata, Mumbai, New Delhi)',
    id: '+TAZug',
    description: 'Asia/Kolkata, TimeZone Offset: +05:30',
  },
  'Asia/Krasnoyarsk': {
    defaultMessage: '(GMT+07:00) North Asia Standard Time (Krasnoyarsk)',
    id: '0CmS5P',
    description: 'Asia/Krasnoyarsk, TimeZone Offset: +07:00',
  },
  'Asia/Novosibirsk': {
    defaultMessage: '(GMT+06:00) N. Central Asia Standard Time (Almaty, Novosibirsk)',
    id: '+K962m',
    description: 'Asia/Novosibirsk, TimeZone Offset: +06:00',
  },
  'Asia/Riyadh': {
    defaultMessage: '(GMT+03:00) Arab Standard Time (Kuwait, Riyadh)',
    id: 'Ql0V9P',
    description: 'Asia/Riyadh, TimeZone Offset: +03:00',
  },
  'Asia/Seoul': {
    defaultMessage: '(GMT+09:00) Korea Standard Time (Seoul)',
    id: '8JrwCl',
    description: 'Asia/Seoul, TimeZone Offset: +09:00',
  },
  'Asia/Shanghai': {
    defaultMessage: '(GMT+08:00) China Standard Time (Beijing, Hong Kong SAR)',
    id: 'LX/LED',
    description: 'Asia/Shanghai, TimeZone Offset: +08:00',
  },
  'Asia/Singapore': {
    defaultMessage: '(GMT+08:00) Singapore Standard Time (Kuala Lumpur, Singapore)',
    id: '9Joj85',
    description: 'Asia/Singapore, TimeZone Offset: +08:00',
  },
  'Asia/Taipei': {
    defaultMessage: '(GMT+08:00) Taipei Standard Time (Taipei)',
    id: '8Qhg6B',
    description: 'Asia/Taipei, TimeZone Offset: +08:00',
  },
  'Asia/Tashkent': {
    defaultMessage: '(GMT+05:00) West Asia Standard Time (Islamabad, Karachi, Tashkent)',
    id: 'RVjz1+',
    description: 'Asia/Tashkent, TimeZone Offset: +05:00',
  },
  'Asia/Tehran': {
    defaultMessage: '(GMT+03:30) Iran Standard Time (Tehran)',
    id: 'efrdpX',
    description: 'Asia/Tehran, TimeZone Offset: +03:30',
  },
  'Asia/Tokyo': {
    defaultMessage: '(GMT+09:00) Tokyo Standard Time (Osaka, Sapporo, Tokyo)',
    id: 'yAWZuV',
    description: 'Asia/Tokyo, TimeZone Offset: +09:00',
  },
  'Asia/Vladivostok': {
    defaultMessage: '(GMT+10:00) Vladivostok Standard Time (Vladivostok)',
    id: 'QuLMx3',
    description: 'Asia/Vladivostok, TimeZone Offset: +10:00',
  },
  'Asia/Yakutsk': {
    defaultMessage: '(GMT+09:00) Yakutsk Standard Time (Yakutsk)',
    id: 'pIgPSC',
    description: 'Asia/Yakutsk, TimeZone Offset: +09:00',
  },
  'Asia/Yangon': {
    defaultMessage: '(GMT+06:30) Myanmar Standard Time (Yangon Rangoon)',
    id: 'Ifb7e0',
    description: 'Asia/Yangon, TimeZone Offset: +06:30',
  },
  'Asia/Yekaterinburg': {
    defaultMessage: '(GMT+05:00) Ekaterinburg Standard Time (Ekaterinburg)',
    id: 'Tp3Zzb',
    description: 'Asia/Yekaterinburg, TimeZone Offset: +05:00',
  },
  'Asia/Yerevan': {
    defaultMessage: '(GMT+04:00) Caucasus Standard Time (Baku, Tbilisi, Yerevan)',
    id: 'EKO3Hf',
    description: 'Asia/Yerevan, TimeZone Offset: +04:00',
  },
  'Atlantic/Azores': {
    defaultMessage: '(GMT-01:00) Azores Standard Time (Azores)',
    id: '7fTSz9',
    description: 'Atlantic/Azores, TimeZone Offset: -01:00',
  },
  'Atlantic/Cape_Verde': {
    defaultMessage: '(GMT-01:00) Cape Verde Standard Time (Cape Verde Islands)',
    id: '++sXhM',
    description: 'Atlantic/Cape_Verde, TimeZone Offset: -01:00',
  },
  'Atlantic/Reykjavik': {
    defaultMessage: '(GMT+00:00) Greenwich Standard Time (Casablanca, Monrovia)',
    id: 'M1Oxyw',
    description: 'Atlantic/Reykjavik, TimeZone Offset: +00:00',
  },
  'Australia/Adelaide': {
    defaultMessage: '(GMT+09:30) Cen. Australia Standard Time (Adelaide)',
    id: 'VWacq0',
    description: 'Australia/Adelaide, TimeZone Offset: +09:30',
  },
  'Australia/Brisbane': {
    defaultMessage: '(GMT+10:00) E. Australia Standard Time (Brisbane)',
    id: 'jTliEA',
    description: 'Australia/Brisbane, TimeZone Offset: +10:00',
  },
  'Australia/Darwin': {
    defaultMessage: '(GMT+09:30) A.U.S. Central Standard Time (Darwin)',
    id: 'sSQhqR',
    description: 'Australia/Darwin, TimeZone Offset: +09:30',
  },
  'Australia/Hobart': {
    defaultMessage: '(GMT+10:00) Tasmania Standard Time (Hobart)',
    id: 'BwuZw4',
    description: 'Australia/Hobart, TimeZone Offset: +10:00',
  },
  'Australia/Perth': {
    defaultMessage: '(GMT+08:00) W. Australia Standard Time (Perth)',
    id: '4EN9TH',
    description: 'Australia/Perth, TimeZone Offset: +08:00',
  },
  'Australia/Sydney': {
    defaultMessage: '(GMT+10:00) A.U.S. Eastern Standard Time (Canberra, Melbourne, Sydney)',
    id: 'wS4GRI',
    description: 'Australia/Sydney, TimeZone Offset: +10:00',
  },
  'Etc/GMT+12': {
    defaultMessage: '(GMT-12:00) Dateline Standard Time (International Date Line West)',
    id: 'GaoK0D',
    description: 'Etc/GMT+12, TimeZone Offset: -12:00',
  },
  'Etc/GMT+2': {
    defaultMessage: '(GMT-02:00) Mid-Atlantic Standard Time (Mid-Atlantic)',
    id: 'SwnwY8',
    description: 'Etc/GMT+2, TimeZone Offset: -02:00',
  },
  'Europe/Berlin': {
    defaultMessage: '(GMT+01:00) W. Europe Standard Time (Amsterdam, Berlin, Rome)',
    id: 'v8Iv+L',
    description: 'Europe/Berlin, TimeZone Offset: +01:00',
  },
  'Europe/Bucharest': {
    defaultMessage: '(GMT+02:00) GTB Standard Time (Athens, Istanbul, Minsk)',
    id: 'yp9PJc',
    description: 'Europe/Bucharest, TimeZone Offset: +02:00',
  },
  'Europe/Budapest': {
    defaultMessage: '(GMT+01:00) Central Europe Standard Time (Belgrade, Budapest, Prague)',
    id: 'mXq+jJ',
    description: 'Europe/Budapest, TimeZone Offset: +01:00',
  },
  'Europe/Chisinau': {
    defaultMessage: '(GMT+02:00) E. Europe Standard Time (Bucharest)',
    id: 'WcZgYb',
    description: 'Europe/Chisinau, TimeZone Offset: +02:00',
  },
  'Europe/Kiev': {
    defaultMessage: '(GMT+02:00) FLE Standard Time (Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius)',
    id: '4idE2/',
    description: 'Europe/Kiev, TimeZone Offset: +02:00',
  },
  'Europe/London': {
    defaultMessage: '(GMT+00:00) GMT Standard Time (Greenwich Mean Time: London)',
    id: 'W1SZhT',
    description: 'Europe/London, TimeZone Offset: +00:00',
  },
  'Europe/Moscow': {
    defaultMessage: '(GMT+03:00) Russian Standard Time (Moscow, St. Petersburg, Volgograd)',
    id: 'UZUTMn',
    description: 'Europe/Moscow, TimeZone Offset: +03:00',
  },
  'Europe/Paris': {
    defaultMessage: '(GMT+01:00) Romance Standard Time (Brussels, Copenhagen, Madrid, Paris)',
    id: 'BUqYZY',
    description: 'Europe/Paris, TimeZone Offset: +01:00',
  },
  'Europe/Warsaw': {
    defaultMessage: '(GMT+01:00) Central European Standard Time (Sarajevo, Warsaw)',
    id: 'Wiu/yx',
    description: 'Europe/Warsaw, TimeZone Offset: +01:00',
  },
  'Pacific/Apia': {
    defaultMessage: '(GMT-11:00) Samoa Standard Time (Midway Island, Samoa)',
    id: 'v5PKNs',
    description: 'Pacific/Apia, TimeZone Offset: -11:00',
  },
  'Pacific/Auckland': {
    defaultMessage: '(GMT+12:00) New Zealand Standard Time (Auckland, Wellington)',
    id: 'HPO26Q',
    description: 'Pacific/Auckland, TimeZone Offset: +12:00',
  },
  'Pacific/Fiji': {
    defaultMessage: '(GMT+12:00) Fiji Islands Standard Time (Fiji Islands)',
    id: 'QwY18L',
    description: 'Pacific/Fiji, TimeZone Offset: +12:00',
  },
  'Pacific/Guadalcanal': {
    defaultMessage: '(GMT+11:00) Central Pacific Standard Time (Solomon Islands)',
    id: 's5zeOk',
    description: 'Pacific/Guadalcanal, TimeZone Offset: +11:00',
  },
  'Pacific/Honolulu': {
    defaultMessage: '(GMT-10:00) Hawaiian Standard Time (Hawaii)',
    id: 'bbPol3',
    description: 'Pacific/Honolulu, TimeZone Offset: -10:00',
  },
  'Pacific/Port_Moresby': {
    defaultMessage: '(GMT+10:00) West Pacific Standard Time (Guam, Port Moresby)',
    id: 'fU2LBq',
    description: 'Pacific/Port_Moresby, TimeZone Offset: +10:00',
  },
  'Pacific/Tongatapu': {
    defaultMessage: "(GMT+13:00) Tonga Standard Time (Nuku'alofa)",
    id: 'JI1CQj',
    description: 'Pacific/Tongatapu, TimeZone Offset: +13:00',
  },
});

const dbTimeZones = [
  {
    timeZoneId: 1,
    name: 'Dateline Standard Time',
    description: '(GMT-12:00) Dateline Standard Time (International Date Line West)',
    utcOffset: '-12:00',
    timeZoneIana: 'Etc/GMT+12',
  },
  {
    timeZoneId: 2,
    name: 'Samoa Standard Time',
    description: '(GMT-11:00) Samoa Standard Time  (Midway Island, Samoa)',
    utcOffset: '-11:00',
    timeZoneIana: 'Pacific/Apia',
  },
  {
    timeZoneId: 3,
    name: 'Hawaiian Standard Time',
    description: '(GMT-10:00) Hawaiian Standard Time (Hawaii)',
    utcOffset: '-10:00',
    timeZoneIana: 'Pacific/Honolulu',
  },
  {
    timeZoneId: 4,
    name: 'Alaskan Standard Time',
    description: '(GMT-09:00) Alaskan Standard Time (Alaska)',
    utcOffset: '-09:00',
    timeZoneIana: 'America/Anchorage',
  },
  {
    timeZoneId: 5,
    name: 'Pacific Standard Time',
    description: '(GMT-08:00) Pacific Standard Time (Pacific Time (US and Canada), Tijuana)',
    utcOffset: '-08:00',
    timeZoneIana: 'America/Los_Angeles',
  },
  {
    timeZoneId: 6,
    name: 'Mountain Standard Time',
    description: '(GMT-07:00) Mountain Standard Time (Mountain Time (US and Canada))',
    utcOffset: '-07:00',
    timeZoneIana: 'America/Denver',
  },
  {
    timeZoneId: 7,
    name: 'Mountain Standard Time (Mexico)',
    description: '(GMT-07:00) Mexico Standard Time 2 (Chihuahua, La Paz, Mazatlan)',
    utcOffset: '-07:00',
    timeZoneIana: 'America/Chihuahua',
  },
  {
    timeZoneId: 8,
    name: 'US Mountain Standard Time',
    description: '(GMT-07:00) U.S. Mountain Standard Time (Arizona)',
    utcOffset: '-07:00',
    timeZoneIana: 'America/Phoenix',
  },
  {
    timeZoneId: 9,
    name: 'Central Standard Time',
    description: '(GMT-06:00) Central Standard Time (Central Time (US and Canada))',
    utcOffset: '-06:00',
    timeZoneIana: 'America/Chicago',
  },
  {
    timeZoneId: 10,
    name: 'Canada Central Standard Time',
    description: '(GMT-06:00) Canada Central Standard Time (Saskatchewan)',
    utcOffset: '-06:00',
    timeZoneIana: 'America/Regina',
  },
  {
    timeZoneId: 11,
    name: 'Central Standard Time (Mexico)',
    description: '(GMT-06:00) Mexico Standard Time (Guadalajara, Mexico City, Monterrey)',
    utcOffset: '-06:00',
    timeZoneIana: 'America/Mexico_City',
  },
  {
    timeZoneId: 12,
    name: 'Central America Standard Time',
    description: '(GMT-06:00) Central America Standard Time (Central America)',
    utcOffset: '-06:00',
    timeZoneIana: 'America/Guatemala',
  },
  {
    timeZoneId: 13,
    name: 'Eastern Standard Time',
    description: '(GMT-05:00) Eastern Standard Time (Eastern Time (US and Canada))',
    utcOffset: '-05:00',
    timeZoneIana: 'America/New_York',
  },
  {
    timeZoneId: 14,
    name: 'US Eastern Standard Time',
    description: '(GMT-05:00) U.S. Eastern Standard Time (Indiana)',
    utcOffset: '-05:00',
    timeZoneIana: 'America/Indiana/Indianapolis',
  },
  {
    timeZoneId: 15,
    name: 'SA Pacific Standard Time',
    description: '(GMT-05:00) S.A. Pacific Standard Time (Bogota, Lima, Quito)',
    utcOffset: '-05:00',
    timeZoneIana: 'America/Bogota',
  },
  {
    timeZoneId: 16,
    name: 'Atlantic Standard Time',
    description: '(GMT-04:00) Atlantic Standard Time (Atlantic Time (Canada))',
    utcOffset: '-04:00',
    timeZoneIana: 'America/Halifax',
  },
  {
    timeZoneId: 17,
    name: 'SA Western Standard Time',
    description: '(GMT-04:00) S.A. Western Standard Time (Caracas, La Paz)',
    utcOffset: '-04:00',
    timeZoneIana: 'America/La_Paz',
  },
  {
    timeZoneId: 18,
    name: 'Pacific SA Standard Time',
    description: '(GMT-04:00) Pacific S.A. Standard Time (Santiago)',
    utcOffset: '-04:00',
    timeZoneIana: 'America/Santiago',
  },
  {
    timeZoneId: 19,
    name: 'Newfoundland Standard Time',
    description: '(GMT-03:30) Newfoundland and Labrador Standard Time (Newfoundland)',
    utcOffset: '-03:30',
    timeZoneIana: 'America/St_Johns',
  },
  {
    timeZoneId: 20,
    name: 'E. South America Standard Time',
    description: '(GMT-03:00) E. South America Standard Time (Brasilia)',
    utcOffset: '-03:00',
    timeZoneIana: 'America/Sao_Paulo',
  },
  {
    timeZoneId: 21,
    name: 'SA Eastern Standard Time',
    description: '(GMT-03:00) S.A. Eastern Standard Time (Buenos Aires, Georgetown)',
    utcOffset: '-03:00',
    timeZoneIana: 'America/Cayenne',
  },
  {
    timeZoneId: 22,
    name: 'Greenland Standard Time',
    description: '(GMT-03:00) Greenland Standard Time (Greenland)',
    utcOffset: '-03:00',
    timeZoneIana: 'America/Godthab',
  },
  {
    timeZoneId: 23,
    name: 'Mid-Atlantic Standard Time',
    description: '(GMT-02:00) Mid-Atlantic Standard Time (Mid-Atlantic)',
    utcOffset: '-02:00',
    timeZoneIana: 'Etc/GMT+2',
  },
  {
    timeZoneId: 24,
    name: 'Azores Standard Time',
    description: '(GMT-01:00) Azores Standard Time (Azores)',
    utcOffset: '-01:00',
    timeZoneIana: 'Atlantic/Azores',
  },
  {
    timeZoneId: 25,
    name: 'Cape Verde Standard Time',
    description: '(GMT-01:00) Cape Verde Standard Time (Cape Verde Islands)',
    utcOffset: '-01:00',
    timeZoneIana: 'Atlantic/Cape_Verde',
  },
  {
    timeZoneId: 26,
    name: 'GMT Standard Time',
    description: '(GMT+00:00) GMT Standard Time (Greenwich Mean Time: London)',
    utcOffset: '+00:00',
    timeZoneIana: 'Europe/London',
  },
  {
    timeZoneId: 27,
    name: 'Greenwich Standard Time',
    description: '(GMT+00:00) Greenwich Standard Time (Casablanca, Monrovia)',
    utcOffset: '+00:00',
    timeZoneIana: 'Atlantic/Reykjavik',
  },
  {
    timeZoneId: 28,
    name: 'Central Europe Standard Time',
    description: '(GMT+01:00) Central Europe Standard Time (Belgrade, Budapest, Prague)',
    utcOffset: '+01:00',
    timeZoneIana: 'Europe/Budapest',
  },
  {
    timeZoneId: 29,
    name: 'Central European Standard Time',
    description: '(GMT+01:00) Central European Standard Time (Sarajevo, Warsaw)',
    utcOffset: '+01:00',
    timeZoneIana: 'Europe/Warsaw',
  },
  {
    timeZoneId: 30,
    name: 'Romance Standard Time',
    description: '(GMT+01:00) Romance Standard Time (Brussels, Copenhagen, Madrid, Paris)',
    utcOffset: '+01:00',
    timeZoneIana: 'Europe/Paris',
  },
  {
    timeZoneId: 31,
    name: 'W. Europe Standard Time',
    description: '(GMT+01:00) W. Europe Standard Time (Amsterdam, Berlin, Rome)',
    utcOffset: '+01:00',
    timeZoneIana: 'Europe/Berlin',
  },
  {
    timeZoneId: 32,
    name: 'W. Central Africa Standard Time',
    description: '(GMT+01:00) W. Central Africa Standard Time (West Central Africa)',
    utcOffset: '+01:00',
    timeZoneIana: 'Africa/Lagos',
  },
  {
    timeZoneId: 33,
    name: 'E. Europe Standard Time',
    description: '(GMT+02:00) E. Europe Standard Time (Bucharest)',
    utcOffset: '+02:00',
    timeZoneIana: 'Europe/Chisinau',
  },
  {
    timeZoneId: 34,
    name: 'Egypt Standard Time',
    description: '(GMT+02:00) Egypt Standard Time (Cairo)',
    utcOffset: '+02:00',
    timeZoneIana: 'Africa/Cairo',
  },
  {
    timeZoneId: 35,
    name: 'FLE Standard Time',
    description: '(GMT+02:00) FLE Standard Time (Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius)',
    utcOffset: '+02:00',
    timeZoneIana: 'Europe/Kiev',
  },
  {
    timeZoneId: 36,
    name: 'GTB Standard Time',
    description: '(GMT+02:00) GTB Standard Time (Athens, Istanbul, Minsk)',
    utcOffset: '+02:00',
    timeZoneIana: 'Europe/Bucharest',
  },
  {
    timeZoneId: 37,
    name: 'Israel Standard Time',
    description: '(GMT+02:00) Israel Standard Time (Jerusalem)',
    utcOffset: '+02:00',
    timeZoneIana: 'Asia/Jerusalem',
  },
  {
    timeZoneId: 38,
    name: 'South Africa Standard Time',
    description: '(GMT+02:00) South Africa Standard Time (Harare, Pretoria)',
    utcOffset: '+02:00',
    timeZoneIana: 'Africa/Johannesburg',
  },
  {
    timeZoneId: 39,
    name: 'Russian Standard Time',
    description: '(GMT+03:00) Russian Standard Time (Moscow, St. Petersburg, Volgograd)',
    utcOffset: '+03:00',
    timeZoneIana: 'Europe/Moscow',
  },
  {
    timeZoneId: 40,
    name: 'Arab Standard Time',
    description: '(GMT+03:00) Arab Standard Time (Kuwait, Riyadh)',
    utcOffset: '+03:00',
    timeZoneIana: 'Asia/Riyadh',
  },
  {
    timeZoneId: 41,
    name: 'E. Africa Standard Time',
    description: '(GMT+03:00) E. Africa Standard Time (Nairobi)',
    utcOffset: '+03:00',
    timeZoneIana: 'Africa/Nairobi',
  },
  {
    timeZoneId: 42,
    name: 'Arabic Standard Time',
    description: '(GMT+03:00) Arabic Standard Time (Baghdad)',
    utcOffset: '+03:00',
    timeZoneIana: 'Asia/Baghdad',
  },
  {
    timeZoneId: 43,
    name: 'Iran Standard Time',
    description: '(GMT+03:30) Iran Standard Time (Tehran)',
    utcOffset: '+03:30',
    timeZoneIana: 'Asia/Tehran',
  },
  {
    timeZoneId: 44,
    name: 'Arabian Standard Time',
    description: '(GMT+04:00) Arabian Standard Time (Abu Dhabi, Muscat)',
    utcOffset: '+04:00',
    timeZoneIana: 'Asia/Dubai',
  },
  {
    timeZoneId: 45,
    name: 'Caucasus Standard Time',
    description: '(GMT+04:00) Caucasus Standard Time (Baku, Tbilisi, Yerevan)',
    utcOffset: '+04:00',
    timeZoneIana: 'Asia/Yerevan',
  },
  {
    timeZoneId: 46,
    name: 'Afghanistan Standard Time',
    description: '(GMT+04:30) Transitional Islamic State of Afghanistan Standard Time (Kabul)',
    utcOffset: '+04:30',
    timeZoneIana: 'Asia/Kabul',
  },
  {
    timeZoneId: 47,
    name: 'Ekaterinburg Standard Time',
    description: '(GMT+05:00) Ekaterinburg Standard Time (Ekaterinburg)',
    utcOffset: '+05:00',
    timeZoneIana: 'Asia/Yekaterinburg',
  },
  {
    timeZoneId: 48,
    name: 'West Asia Standard Time',
    description: '(GMT+05:00) West Asia Standard Time (Islamabad, Karachi, Tashkent)',
    utcOffset: '+05:00',
    timeZoneIana: 'Asia/Tashkent',
  },
  {
    timeZoneId: 49,
    name: 'India Standard Time',
    description: '(GMT+05:30) India Standard Time (Chennai, Kolkata, Mumbai, New Delhi)',
    utcOffset: '+05:30',
    timeZoneIana: 'Asia/Kolkata',
  },
  {
    timeZoneId: 50,
    name: 'Nepal Standard Time',
    description: '(GMT+05:45) Nepal Standard Time (Kathmandu)',
    utcOffset: '+05:45',
    timeZoneIana: 'Asia/Kathmandu',
  },
  {
    timeZoneId: 51,
    name: 'Central Asia Standard Time',
    description: '(GMT+06:00) Central Asia Standard Time (Astana, Dhaka)',
    utcOffset: '+06:00',
    timeZoneIana: 'Asia/Almaty',
  },
  {
    timeZoneId: 52,
    name: 'Sri Lanka Standard Time',
    description: '(GMT+06:00) Sri Lanka Standard Time Sri (Jayawardenepura)',
    utcOffset: '+06:00',
    timeZoneIana: 'Asia/Colombo',
  },
  {
    timeZoneId: 53,
    name: 'N. Central Asia Standard Time',
    description: '(GMT+06:00) N. Central Asia Standard Time (Almaty, Novosibirsk)',
    utcOffset: '+06:00',
    timeZoneIana: 'Asia/Novosibirsk',
  },
  {
    timeZoneId: 54,
    name: 'Myanmar Standard Time',
    description: '(GMT+06:30) Myanmar Standard Time (Yangon Rangoon)',
    utcOffset: '+06:30',
    timeZoneIana: 'Asia/Yangon',
  },
  {
    timeZoneId: 55,
    name: 'SE Asia Standard Time',
    description: '(GMT+07:00) S.E. Asia Standard Time (Bangkok, Hanoi, Jakarta)',
    utcOffset: '+07:00',
    timeZoneIana: 'Asia/Bangkok',
  },
  {
    timeZoneId: 56,
    name: 'North Asia Standard Time',
    description: '(GMT+07:00) North Asia Standard Time (Krasnoyarsk)',
    utcOffset: '+07:00',
    timeZoneIana: 'Asia/Krasnoyarsk',
  },
  {
    timeZoneId: 57,
    name: 'China Standard Time',
    description: '(GMT+08:00) China Standard Time (Beijing, Hong Kong SAR)',
    utcOffset: '+08:00',
    timeZoneIana: 'Asia/Shanghai',
  },
  {
    timeZoneId: 58,
    name: 'Singapore Standard Time',
    description: '(GMT+08:00) Singapore Standard Time (Kuala Lumpur, Singapore)',
    utcOffset: '+08:00',
    timeZoneIana: 'Asia/Singapore',
  },
  {
    timeZoneId: 59,
    name: 'Taipei Standard Time',
    description: '(GMT+08:00) Taipei Standard Time (Taipei)',
    utcOffset: '+08:00',
    timeZoneIana: 'Asia/Taipei',
  },
  {
    timeZoneId: 60,
    name: 'W. Australia Standard Time',
    description: '(GMT+08:00) W. Australia Standard Time (Perth)',
    utcOffset: '+08:00',
    timeZoneIana: 'Australia/Perth',
  },
  {
    timeZoneId: 61,
    name: 'North Asia East Standard Time',
    description: '(GMT+08:00) North Asia East Standard Time (Irkutsk, Ulaanbaatar)',
    utcOffset: '+08:00',
    timeZoneIana: 'Asia/Irkutsk',
  },
  {
    timeZoneId: 62,
    name: 'Korea Standard Time',
    description: '(GMT+09:00) Korea Standard Time (Seoul)',
    utcOffset: '+09:00',
    timeZoneIana: 'Asia/Seoul',
  },
  {
    timeZoneId: 63,
    name: 'Tokyo Standard Time',
    description: '(GMT+09:00) Tokyo Standard Time (Osaka, Sapporo, Tokyo)',
    utcOffset: '+09:00',
    timeZoneIana: 'Asia/Tokyo',
  },
  {
    timeZoneId: 64,
    name: 'Yakutsk Standard Time',
    description: '(GMT+09:00) Yakutsk Standard Time (Yakutsk)',
    utcOffset: '+09:00',
    timeZoneIana: 'Asia/Yakutsk',
  },
  {
    timeZoneId: 65,
    name: 'AUS Central Standard Time',
    description: '(GMT+09:30) A.U.S. Central Standard Time (Darwin)',
    utcOffset: '+09:30',
    timeZoneIana: 'Australia/Darwin',
  },
  {
    timeZoneId: 66,
    name: 'Cen. Australia Standard Time',
    description: '(GMT+09:30) Cen. Australia Standard Time (Adelaide)',
    utcOffset: '+09:30',
    timeZoneIana: 'Australia/Adelaide',
  },
  {
    timeZoneId: 67,
    name: 'AUS Eastern Standard Time',
    description: '(GMT+10:00) A.U.S. Eastern Standard Time (Canberra, Melbourne, Sydney)',
    utcOffset: '+10:00',
    timeZoneIana: 'Australia/Sydney',
  },
  {
    timeZoneId: 68,
    name: 'E. Australia Standard Time',
    description: '(GMT+10:00) E. Australia Standard Time (Brisbane)',
    utcOffset: '+10:00',
    timeZoneIana: 'Australia/Brisbane',
  },
  {
    timeZoneId: 69,
    name: 'Tasmania Standard Time',
    description: '(GMT+10:00) Tasmania Standard Time (Hobart)',
    utcOffset: '+10:00',
    timeZoneIana: 'Australia/Hobart',
  },
  {
    timeZoneId: 70,
    name: 'Vladivostok Standard Time',
    description: '(GMT+10:00) Vladivostok Standard Time (Vladivostok)',
    utcOffset: '+10:00',
    timeZoneIana: 'Asia/Vladivostok',
  },
  {
    timeZoneId: 71,
    name: 'West Pacific Standard Time',
    description: '(GMT+10:00) West Pacific Standard Time (Guam, Port Moresby)',
    utcOffset: '+10:00',
    timeZoneIana: 'Pacific/Port_Moresby',
  },
  {
    timeZoneId: 72,
    name: 'Central Pacific Standard Time',
    description: '(GMT+11:00) Central Pacific Standard Time (Solomon Islands)',
    utcOffset: '+11:00',
    timeZoneIana: 'Pacific/Guadalcanal',
  },
  {
    timeZoneId: 73,
    name: 'Fiji Standard Time',
    description: '(GMT+12:00) Fiji Islands Standard Time (Fiji Islands)',
    utcOffset: '+12:00',
    timeZoneIana: 'Pacific/Fiji',
  },
  {
    timeZoneId: 74,
    name: 'New Zealand Standard Time',
    description: '(GMT+12:00) New Zealand Standard Time (Auckland, Wellington)',
    utcOffset: '+12:00',
    timeZoneIana: 'Pacific/Auckland',
  },
  {
    timeZoneId: 75,
    name: 'Tonga Standard Time',
    description: "(GMT+13:00) Tonga Standard Time (Nuku'alofa)",
    utcOffset: '+13:00',
    timeZoneIana: 'Pacific/Tongatapu',
  },
];

export const TimeZones = dbTimeZones.map((tz) => ({
  ...tz,
  messageDescriptor: messages[tz.timeZoneIana],
}));

export const DefaultSSTimeZone = {
  timeZoneId: 9,
  name: 'Central Standard Time',
  description: '(GMT-06:00) Central Standard Time (Central Time (US and Canada))',
  utcOffset: '-06:00',
  timeZoneIana: 'America/Chicago',
  messageDescriptor: messages['America/Chicago'],
};
